import React from 'react';
import '../styles/LockedBadge.css';
export default function LockedBadge() {
  return <span className="locked-field"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2.5" /><path d="M8 10V7a4 4 0 018 0v3M12 14.5v2" /></svg>Locked</span>;
}
